export default __webpack_public_path__ + "static/media/Restart_pfp.58b3ae2d.png";